import React from 'react';
import style from './style.module.scss';
import { Row, Col } from 'react-bootstrap';
import Tabs from '../../lib/tabs';
import ToDoTab from './content/to_do_tab';
import CompletedTab from './content/completed_tab';
import PlanMixExpansionPanel from './content/plan_mix_expansion_panel';
import { YourClassesProvider } from '@magoosh/pages/live_classes/all_classes/context';
import { UserProvider } from '@magoosh/context/user_context';
import { StudyPlanProvider } from './context';
import SideBar from '../../organisms/side_bar';
import { paths } from 'config/path_helpers';
import { HighlightAlert } from '@magoosh/lib/alerts';
import colors from '@magoosh/lib/styles/colors.module.scss';

export const StudyPlan: React.FC = () => {
  return (
    <UserProvider>
      <YourClassesProvider>
        <StudyPlanProvider>
          <div className={style.studyPlan}>
            <HighlightAlert className="u-margin-B-m">
              You are using an outdated version of Magoosh that will be retired at the end of August. <strong><a href="/ab_tests/abandon" style={{ color: colors.purple }}>Switch to the updated version of GRE prep</a></strong>
            </HighlightAlert>

            <Row>
              <Col sm={8}>
                <Row>
                  <Col sm={12} md={5} mdPush={7}>
                    <PlanMixExpansionPanel />
                  </Col>
                  <Col sm={12} md={7} mdPull={5}>
                    <h2 className="u-margin-T-n">
                      <strong>Your Study Plan</strong>
                    </h2>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <p className="u-margin-A-n">
                      As you study, you will get new recommendations to stay focused on the GRE topics that
                      will help improve your score the most.
                    </p>
                    <a style={{ color: style.grayDarker }} href={paths.topicOverview()}>
                      See Topic Overview
                    </a>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col sm={12}>
                    <Tabs defaultTab="todo">
                      <Tabs.Tab tab="todo">To Do</Tabs.Tab>
                      <Tabs.Tab tab="completed">Done</Tabs.Tab>

                      <Tabs.Panel tab="todo">
                        <ToDoTab />
                      </Tabs.Panel>
                      <Tabs.Panel tab="completed">
                        <CompletedTab />
                      </Tabs.Panel>
                    </Tabs>
                  </Col>
                </Row>
              </Col>
              <Col sm={4}>
                <SideBar />
              </Col>
            </Row>
          </div>
        </StudyPlanProvider>
      </YourClassesProvider>
    </UserProvider>
  );
};

export default StudyPlan;
